import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { ContractSearchProvider } from './context/contract-search-context';
import { ContractSearchComponent } from './contract-search-component';

export function ContractSearchFactory() {
    return (
        <BaseLayoutFactory>
            <ContractSearchProvider>
                <ContractSearchComponent />
            </ContractSearchProvider>
        </BaseLayoutFactory>
    );
}
